// extracted by mini-css-extract-plugin
export default {"cardd":"style_cardd__I37UK","btnn":"style_btnn__97U9p","t":"style_t__nLmdg","s":"style_s__FXgy6","c":"style_c__z5dcO","icon":"style_icon__WY6Oz"};